import { CompiledAgreementSignatureSlot } from 'bff'
import { translate } from 'i11n'
import {
  AGREEMENT_SIGNATURE_BOX_MM,
  AGREEMENT_SIGNATURE_SLOT_MM,
} from 'piramid-constants'

interface SignatureSlotProps {
  slot: CompiledAgreementSignatureSlot
}

/** Renglón para completar a mano: la línea llega hasta el ancho de la columna. */
const SignatureLine = ({ label }: { label: string }) => (
  <div className='mt-2.5 flex items-end gap-1 text-[7pt] leading-tight text-zinc-500'>
    <span className='whitespace-nowrap'>{label}:</span>
    <span className='flex-1 border-b border-zinc-400' />
  </div>
)

/**
 * Recuadro de firma con su ancla. El token (`[[SIG:<key>]]`) se imprime en
 * 1 pt blanco en la esquina superior izquierda: el localizador de anclas (API)
 * lo encuentra en el texto del PDF y esa posición es la esquina del recuadro
 * donde el proveedor de firma dibuja el campo. El tamaño sale de la misma
 * constante con la que el localizador lo convierte a porcentaje de página, y
 * va inline porque Tailwind no genera clases con valores dinámicos.
 */
export const SignatureSlot = ({ slot }: SignatureSlotProps) => (
  <div
    className='break-inside-avoid'
    style={{ width: `${AGREEMENT_SIGNATURE_SLOT_MM.width}mm` }}
  >
    <div
      className='relative border border-zinc-400'
      style={{
        width: `${AGREEMENT_SIGNATURE_BOX_MM.width}mm`,
        height: `${AGREEMENT_SIGNATURE_BOX_MM.height}mm`,
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          fontSize: '1pt',
          lineHeight: '1pt',
          color: '#ffffff',
          whiteSpace: 'nowrap',
        }}
      >
        {slot.token}
      </span>
    </div>
    <p className='mt-1 text-[7pt] font-medium uppercase leading-tight'>
      {slot.label}
    </p>
    {slot.with_name && (
      <>
        <SignatureLine label={translate('document.agreement.signature.name')} />
        <SignatureLine
          label={translate('document.agreement.signature.identification')}
        />
      </>
    )}
    {slot.with_date && (
      <SignatureLine label={translate('document.agreement.signature.date')} />
    )}
  </div>
)
